module.exports = __webpack_public_path__ + "img/catalina-becerra-byn.34af857a.jpg";